import React from "react";
import { useAuth } from "../context/authContext";
import { Navigate, Outlet } from "react-router-dom";
import Loader from "../components/loader";

/**
 * RoleRoute protège une route pour des rôles donnés.
 * Redirige :
 * - vers / si l'utilisateur n'est pas authentifié ;
 * - vers /forbidden s'il est authentifié mais n'a pas les droits.
 */
interface RoleRouteProps {
  allowedRoles: string[];
}

const RoleRoute: React.FC<RoleRouteProps> = ({ allowedRoles }) => {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) return <Loader />;

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (user && allowedRoles.includes(user.role)) {
    return <Outlet />;
  }

  return <Navigate to="/forbidden" />;
};

export default RoleRoute;
